import { Component } from '@angular/core';
import { AuthService } from '@/auth/service/auth.service';
import { Store } from '@ngrx/store';
import { StoreState } from '@/store';
import { getCurrentUserData } from '@/store/login/selectors';
import { normalize } from '@/utils/normalizeString';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent {

  shouldShowRole: boolean = false;
  roleText: string = '';
  employeeType: string = '';

  constructor(
    private auth: AuthService,
    private store: Store<StoreState>,
  ) {
    const currentRole = this.auth.getMyRole();
    console.log(currentRole);
    this.roleText = `${currentRole.name} - ${currentRole.description}`;
    getCurrentUserData(this.store).subscribe({
      next: ({ entity }) => {
        this.employeeType = entity;
      },
    });

    const appUris = [
      {
        frontUri: 'https://scl0eddlm01.americas.ent.bhpbilliton.net:4001/',
        bffUri: 'https://scl0eddlm01.americas.ent.bhpbilliton.net:4003/',
      },
      {
        frontUri: 'https://dlms-test.minam.bhp.com/',
        bffUri: 'https://scl0etdlm01.americas.ent.bhpbilliton.net:4003/',
      },
      {
        frontUri: 'https://localhost:4200/',
        bffUri: 'https://scl0eddlm01.americas.ent.bhpbilliton.net:4003/',
      },
      {
        frontUri: 'https://dlms-qa.bhp.com/',
        bffUri: 'https://hou-api-qa.bhp.com/qaextexp-dlms-api-proxy/',
      },
    ];
    this.shouldShowRole = appUris.some((appUri) => {
      const key = appUri.frontUri.replace('https://', '').replace('http://', '').replace('/', '');
      return normalize(window.location.href).slice(0, 70).includes(normalize(key));
    });
  }

}
